import {ApiClient} from './api'
export class ShopperBasketService {
    baseUrl = '/api/adyen/basket'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    async updateBasket(basketId, data) {
        const res = await this.apiClient.post({
            body: JSON.stringify(data),
            headers: {
                basketid: basketId
            }
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            return await res.json()
        }
    }
}
